import { Component } from '@angular/core';

@Component({
  selector: 'overview-support-page',
  templateUrl: './overview-support-page.component.html',
  styleUrls: ['./overview-support-page.component.scss']
})
export class OverviewSupportPageComponent {

  public loader     = false;

}
